export default __webpack_public_path__ + "static/media/apAiLogo.0b0234ee.png";